import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/document-types')({
  staticData: { breadcrumb: 'Document Types', breadcrumbKey: 'K_BREADCRUMB_DOCUMENT_TYPES' },
  component: DocumentTypesLayout,
});

function DocumentTypesLayout() {
  return <Outlet />;
}
